import { api } from '@/api/axios-instance';
import { parseResponse } from '@/api/parse-response';
import { sparseLocationWithParentSchema } from '@/sparse/api/types';
import { z } from 'zod';

const validationErrorFieldSchema = z.object({
  fieldName: z.string(),
  error: z.string(),
  errorCode: z.number(),
});

const processedLocationDataSchema = z.object({
  locationName: z.string(),
  index: z.number(),
  created: z.boolean(),
  updated: z.boolean(),
  noOp: z.boolean(),
  validatedLocation: sparseLocationWithParentSchema.nullable(),
  fieldsUpdated: z.record(z.boolean()),
  errors: z.array(validationErrorFieldSchema),
});

const rowErrorDataSchema = z.object({
  index: z.number(),
  errors: z.array(validationErrorFieldSchema),
});

export const uploadLocationDataResponseSchema = z.object({
  data: z.object({
    success: z.boolean(),
    items: z.array(processedLocationDataSchema),
    structureErrors: z.array(validationErrorFieldSchema),
    rowErrors: z.array(rowErrorDataSchema),
  }),
});

export type LocationDataUploadResult = z.infer<
  typeof uploadLocationDataResponseSchema
>['data'];

export async function uploadLocationData(
  formData: FormData
): Promise<LocationDataUploadResult> {
  const url = '/v1/import/location-data';
  const response = await api.post(url, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });

  const parsed = await parseResponse(
    uploadLocationDataResponseSchema,
    response.data,
    {
      schemaName: 'UploadLocationData',
      endpoint: url,
    }
  );
  return parsed.data;
}
